import React, { Component } from "react";
import { NavBar } from "../../components/Navbar";
import HeroSmart from "../../components/HeroSmart";
import Footer from "../../components/Footer";
import styled from "styled-components";

export default class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: props.user,
      mobileNavHidden: true,
    };
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({ mobileNavHidden: true });
  }

  toggleMobileNav() {
    this.setState({ mobileNavHidden: !this.state.mobileNavHidden });
  }

  render() {
    return (
      <div className="error_root">
        <HeroSmart
          login={false}
          backgroundName={"https://tubac-woodworks.s3-us-west-1.amazonaws.com/error.jpg"}
          title="Terms of Service"
          subTitle=""
        />
        <NavBar isHidden={this.state.mobileNavHidden} toggle={this.toggleMobileNav} />
        <StyledSection>
          <h4>
            Terms of Service Last updated: <time>10/21/2026</time>
          </h4>
          <h2>Tubac Woodworks LLC</h2>

          <p className="p1">
            <span className="s1">
              Welcome to Tubac Woodworks, LLC ("us", "we", or "our"). These Terms of Service ("Terms") govern your access to and use of our website hosted at{" "}
              <a href="https://www.tubacwoodworks.com/" target="_blank" rel="noopener noreferrer">
                <span className="s2">https://www.tubacwoodworks.com</span>
              </a>{" "}
              and any related services, tools, and applications (collectively, the "Service").
            </span>
          </p>
          <p className="p1">
            <span className="s1">
              By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you may not access the Service.
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>1. User Accounts &amp; Authentication</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              To access certain features of our Service, you may be required to register for an account or authenticate using third-party services such as Google Sign-In. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>2. Third-Party Services &amp; Google APIs</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              Our Service integrates with third-party APIs, including Google API Services. By using features that connect to your Google Account, you grant us permission to access specific account information necessary to operate those features.
            </span>
          </p>
          <p className="p1">
            <span className="s1">
              Our use and transfer of information received from Google APIs to any other app will strictly adhere to the{" "}
              <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">
                <span className="s2">Google API Services User Data Policy</span>
              </a>
              , including the Limited Use requirements.
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>3. Acceptable Use</b></span>
          </h2>
          <p className="p1">
            <span className="s1">You agree not to engage in any of the following prohibited activities:</span>
          </p>
          <ul className="ul1">
            <li className="li1">
              <span className="s1">Attempting to interfere with, compromise system integrity or security, or decipher any transmissions to or from the servers running the Service.</span>
            </li>
            <li className="li1">
              <span className="s1">Using the Service for any unlawful purpose or in violation of any local, state, national, or international law.</span>
            </li>
            <li className="li1">
              <span className="s1">Bypassing any measures we may use to prevent or restrict access to the Service.</span>
            </li>
          </ul>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>4. Termination &amp; Revocation</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              We may terminate or suspend your access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
            </span>
          </p>
          <p className="p1">
            <span className="s1">
              You may stop using our Service at any time. You can also revoke our application’s access to your Google account at any time via your{" "}
              <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener noreferrer">
                <span className="s2">Google Security Settings</span>
              </a>
              .
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>5. Limitation of Liability</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              In no event shall Tubac Woodworks, LLC, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>6. Changes to Terms</b></span>
          </h2>
          <p className="p1">
            <span className="s1">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide notice of material changes by posting the new Terms on this page with an updated effective date.
            </span>
          </p>

          <h2 style={{ margin: "0.0px 0.0px 14.9px 0.0px", font: "18.0px Times", WebkitTextStroke: "#000000" }}>
            <span className="s1"><b>Contact Us</b></span>
          </h2>
          <p className="p1">
            <span className="s1">If you have any questions about these Terms, please contact us:</span>
          </p>
          <ul className="ul1">
            <li className="li1"><span className="s1"><b>Email:</b> info@tubacwoodworks.com or tubacww@gmail.com</span></li>
            <li className="li1"><span className="s1"><b>Phone:</b> (520) 625-0050</span></li>
            <li className="li1"><span className="s1"><b>Address:</b> 25700 S Via Montana Vista, Green Valley, AZ 85622</span></li>
          </ul>
        </StyledSection>
        <Footer />
      </div>
    );
  }
}

// ========== //
//   STYLES   //
// ========== //
const StyledSection = styled.section`
  max-width: 1400px;
  padding: 1em;
  margin: 0 auto;

  h2,
  h3 {
    font-weight: 800;
  }

  h4 {
    font-size: 1em;
    font-weight: 200;
  }

  p {
    max-width: 80%;
  }

  p.p1 {
    
  }

  li.li1 {
    
  }

  span.s1 {
    font-kerning: none;
  }

  span.s2 {
    text-decoration: underline;
    font-kerning: none;
    color: #0000e9;
    -webkit-text-stroke: 0px #0000e9;
  }

  ul.ul1 {
    list-style-type: disc;
  }

  a,
  a:hover,
  a:active,
  a:visited {
    color: #c0392b;
    font-weight: 800;
  }
`;
